import { useDispatch, useSelector } from 'react-redux';
import {
    goThroughSteps,
    nextSignInProcessStep,
    resetSignInProcess,
} from 'redux/actions/internal/general/auth';
import { RootState } from 'redux/reducers';
import { SignInProcessStep } from 'redux/types/internalTypes';

export const useSignInProcess = () => {
    const signInProcessInfo = useSelector((state: RootState) => state.signInProcessInfo);
    const dispatch = useDispatch();

    return {
        currentStep: signInProcessInfo.data.currentStep,
        hasBeenThrough: (...steps: SignInProcessStep[]) =>
            steps.every(step => signInProcessInfo.data.previousSteps.includes(step)),
        nextStep: (step: SignInProcessStep) => dispatch(nextSignInProcessStep(step)),
        resetProcess: () => dispatch(resetSignInProcess()),
        goThrough: (steps: Array<SignInProcessStep>, step: SignInProcessStep) =>
            dispatch(goThroughSteps(steps, step)),
        hasBeenThroughOnlyPhone: () => {
            const arr = signInProcessInfo.data.previousSteps;
            return (
                arr.includes('LOGIN_WITH_PHONE') &&
                !arr.includes('LOGIN_WITH_EMAIL') &&
                !arr.includes('SOCIAL_GOOGLE')
            );
        },
    };
};
